/**
 * Toggles the active state of the dropdown when mouse enters or leaves.
 *
 * @param {Event} event - The mouse event object.
 * @param {boolean} isEntering - Whether the event is mouseenter.
 */
function toggleDropdown(event, isEntering) {
	const dropdown = event.target.closest('.js-dropdown');

	if (!dropdown) return;

	const body = document.body;

	if (isEntering) {
		body.classList.add('active');
		dropdown.classList.add('active');
	} else {
		body.classList.remove('active');
		dropdown.classList.remove('active');
	}
}

/**
 * Adds mouseenter and mouseleave event listeners to the header for dropdowns.
 */
function headerListeners() {
	const header = document.querySelector('.header');

	if (!header) return;

	header.addEventListener('mouseenter', (event) => toggleDropdown(event, true), true);
	header.addEventListener('mouseleave', (event) => toggleDropdown(event, false), true);
}

// Initialise the event listeners when the DOM is fully loaded.
// document.addEventListener('DOMContentLoaded', headerListeners);
